import { AccountingMode } from "@bruhat/shared";
import { useAccountingMode } from "@/hooks/use-accounting-mode";

/**
 * Where "home" is for the person looking at the screen.
 *
 * Simple Mode has its own home — the business overview — and the accountant
 * screens have theirs. `/dashboard` was written in three places that all mean
 * "home": the sidebar logo, the Dashboard item in the navigation, and the
 * landing redirect. Two of them ignored the mode, so a site manager in Simple
 * Mode who clicked the logo (the universal "take me home" gesture) or the
 * Dashboard item landed in a screen full of debits and credits.
 *
 * One definition, used by all three.
 */
export function useHomePath(): string {
  const { mode } = useAccountingMode();
  return mode === AccountingMode.SIMPLE ? "/simple" : "/dashboard";
}

/**
 * What that home is called.
 *
 * "Dashboard" is the accountant's word for it and the Simple screen is titled
 * "Business overview" — a navigation item that does not match the page it opens
 * is a small, constant friction.
 */
export function useHomeLabel(): string {
  const { mode } = useAccountingMode();
  return mode === AccountingMode.SIMPLE ? "Business overview" : "Dashboard";
}
